import React  from "react";
import PropTypes from "prop-types";

import Slider from "@material-ui/core/Slider";
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


const muiTheme1 = createTheme({
    
    overrides: {
        MuiSlider: {
            thumb: {
                color: "blue",
            },
            track: {
                color: 'grey'
            },
            rail: {
                color: 'black',
            }
        },
        
    },
    typography: {
        fontFamily: 'Objective-Regular',
        fontSize: 20,
    },
    palette: {
        text: {
            primary: 'black',
            secondary: 'black',
            disabled: 'grey'
        }
    }

});


function valuetext(value) {
    return `${value}`;
}

function calcScale(min, max) {
    let pos = min;

    let scale = [];
    let medValue = Math.round((min + max) / 2);
    scale.push({ value: min, label: min.toString() });
    scale.push({ value: medValue, label: medValue.toString() });
    scale.push({ value: max, label: max.toString() });
        
    return scale;
}

const  ThermometerHorsz = (props) => {
    const { min, max, posTemp, handleValueChange, posValue, disabled  } = props;
    //const scale = calcScale(min, max);
    const [value, setValue] = React.useState(Number(posValue));
   
    // handleValueChange = Min or Max handle function
    const handleChange = (event, newValue) => {
        event.preventDefault();
        if (value !== newValue ) {
            handleValueChange(newValue);
            setValue(newValue);
        }
    };

    return (
        <ThemeProvider theme={muiTheme1}>
            <Slider
                key={`slider-${posTemp}-${min}-${max}`}
                disabled={disabled}
                value={posValue ? posValue : min}  
                getAriaValueText={valuetext}
                min={min}
                max={max}            
                step={0.1}
                onChange={handleChange}     
            />
        </ThemeProvider>
    );
}

export default ThermometerHorsz;

ThermometerHorsz.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    posValue: PropTypes.number.isRequired,
    posTemp: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
}